import {
  DeleteOutlined,
  EditOutlined,
  SaveOutlined,
  LogoutOutlined,
  MinusCircleOutlined,
} from "@ant-design/icons";
import { Checkbox, Col, Form, Row, Space, Button, message } from "antd";
import ButtonComponent from "components/ButtonComponent";
import DrawerComponent from "components/DrawerComponent";
import TableComponent from "components/TableComponent";
import TableConfig from "components/TableConfig";
import FormComponent from "components/form/FormComponent";
import InputCheckbox from "components/form/InputCheckbox";
import InputSelect from "components/form/InputSelect";
import InputText from "components/form/InputText";
import InputTextarea from "components/form/InputTextarea";
import {
  ErrorNotification,
  SuccessNotification,
} from "components/popup/Notifications";
import PopDelete from "components/popup/PopDelete";
import useFormHook from "hooks/useFormHook";
import React, { useEffect, useState, useRef } from "react";
import { Post } from "utils/CrudApi";
import { Operations } from "utils/constants";
import { dummyQuotationData } from "utils/dummy";
import { dummybranches, dummydepartments, items } from "utils/dummy";
import NewFormComponent from "components/form/NewFormComponent";
import InputDate from "components/form/InputDate";
import { InfoNotification } from "components/popup/Notifications";
import { getItemsNames } from "utils/functions";
import {
  getDepartmentAccordingBranch,
  getTransactionDetail,
} from "utils/functions";
import DemandForm from "components/form/DemandForm";

const initialValues = {
  OperationId: 1,
  Id: null,
  ReferenceNo: null,
  TransactionTypeId: null,
  DemandOrderId: null,
  TransactionDate: null,
  TransactionNo: "",
  SupplierId: null,
  DepartmentId: null,
  ToDepartmentId: null,
  BranchId: null,
  UserId: 1,
  Gross: 0,
  Tax: 0,
  Discount: 0,
  Amount: 0,
  TimeStamp: "",
  Enabled: 1,
  Deleted: 0,
  IsSubmit: false,
  TransType: "DEMAND_ORDER",
  TransactionDetail: [],
};

export default function Quotation() {
  const {
    firstFieldRef,
    tempRows,
    isLoading,
    isTableLoading,
    handleDelete,
    handleDrawer,
    handleEdit,
    handleOpeningInventoryEdit,
    handleSearch,
    handleSubmit,
    handleOpeningInventorySubmit,
    handleAdd,
    handleSubmitAll,
    open,
    add,
    formData,
    search,
    dataSet,
    transformOptions,
    inputRef,
    itemCodeRefs,
    quantityRefs,
  } = useFormHook("GRN", initialValues);
  const { getColumnSearchProps, sort, sortString } = TableConfig();
  const [formValues, setFormValues] = useState({});
  const [filteredDepartments, setFilteredDepartments] = useState(
    transformOptions(dataSet?.Table2)
  );
  const [currentIndex, setCurrentIndex] = useState(null);
  const itemsOptions = getItemsNames(dataSet?.Table6);
  const [drawerTableData, setDrawerTableData] = useState([]);
  const [isEdit, setIsEdit] = useState(false);
  const [isDisabled, setIsDisabled] = useState(false)
  console.log("drawer table data checking for changes ... ", drawerTableData);
  console.log("checking form values for submitted", formValues);

  useEffect(() => {
    if (dataSet?.Table6) {
        setDrawerTableData(dataSet.Table6);
    }
}, [dataSet]); // Dependency array includes dataSet

  const mainPageTableColumns = [
    {
      key: "1",
      title: "Branch",
      dataIndex: "BranchName",
      ...getColumnSearchProps("BranchName"),
      ...sortString("Name"),
    },
    {
      key: "2",
      title: "Department",
      dataIndex: "DepartmentName",
      ...getColumnSearchProps("DepartmentName"),
      ...sort("ShortName"),
    },
    {
      key: "3",
      title: "Demand Number",
      dataIndex: "TransactionNo",
      // className: "text-center",
    },
    {
      key: "4",
      title: "Demand Date",
      dataIndex: "TransactionDate",
      // className: "text-center",
    },
    {
      key: "5",
      title: "IsSubmit",
      dataIndex: "IsSubmit",
      render: (text) => (text ? "true" : "false"),
    },
    {
      key: "6",
      title: "Action",
      // className: "text-center",
      render: (_, record) => (
        <Space>
          {" "}
          <ButtonComponent
            icon={<EditOutlined />}
            onClick={() => {
              handleDemandEdit(record);
              handleOpeningInventoryEdit(record);
              setFormValues({
                TransactionDate: record.TransactionDate,
                DepartmentName: record.DepartmentId,
                Id: record.Id,
              });
              setIsEdit(true);
              
            }}
          />{" "}
          <PopDelete handleDelete={() => handleDelete(record)}>
            <ButtonComponent disabled={record.IsSubmit} icon={<DeleteOutlined />} danger={true} />{" "}
          </PopDelete>
        </Space>
      ),
    },
  ];

  const drawerTableColumns = [
    {
      key: "1",
      title: "Item Code",
      dataIndex: "ItemCode",
      ...getColumnSearchProps("ItemCode"),
    },
    {
      key: "4",
      title: "Item Name",
      dataIndex: "ItemName",
      ...getColumnSearchProps("ItemName"),
    },
    {
      key: "2",
      title: "Category",
      dataIndex: "CategoryName",
      ...getColumnSearchProps("CategoryName"),
    },
    {
      key: "3",
      title: "Sub Category",
      dataIndex: "SubCategoryName",
      ...getColumnSearchProps("SubCategoryName"),
    },
    {
      key: "3",
      title: "Issuance Unit",
      dataIndex: "IssuanceUnit",
      ...getColumnSearchProps("IssuanceUnit"),
    },
    {
      key: "6",
      title: "Quantity",
      dataIndex: "Quantity",
      render: (_, record, index) => {
        return (
          <InputText
            type="number"
            value={record.Quantity}
            ref={(el) => (quantityRefs.current[index] = el)}
            onChange={(e) => handleQuantityChange(e, index)}
            onKeyPress={(e) => handleQuantityKeyPress(e, e.target.value, index)}
          />
        );
      },
    },
    {
      key: "6",
      title: "Action",
      render: (_, record) => (
        <Space>
          {" "}
          <PopDelete handleDelete={() => {}}>
            <ButtonComponent
              icon={<MinusCircleOutlined />}
              danger={true}
              type={"dashed"}
            />{" "}
          </PopDelete>
        </Space>
      ),
    },
  ];

  const formFields = (
    <Row gutter={[20, 0]}>
      <Col xs={24} md={12} xl={8}>
        <InputText
          disabled={true}
          type="text"
          label={"Demand Number"}
          name={"TransactionNo"}
        />
      </Col>
      <Col xs={24} md={12} xl={8}>
        <InputSelect
          label={"Branch"}
          name={"BranchName"}
          options={transformOptions(dataSet?.Table2)}
          onChange={(value) => {
            if (value) {
              // Filter departments based on selected branch
              const departments = getDepartmentAccordingBranch(
                dataSet?.Table3,
                value
              );
              setFilteredDepartments(transformOptions(departments));
            } else {
              setFilteredDepartments(transformOptions(dataSet?.Table2));
            }
          }}
        />
      </Col>
      <Col xs={24} md={12} xl={8}>
        <InputSelect
          label={"Department"}
          name={"DepartmentName"}
          options={filteredDepartments}
        />
      </Col>
      <Col xs={24} md={12} xl={8}>
        <InputDate label={"Demand Date"} name={"TransactionDate"} />
      </Col>
    </Row>
  );

  const searchFields = (
    <Row gutter={[20, 0]}>
      <Col xs={24} md={12} xl={8}>
        <InputText label={"Demand Number"} name={"Name"} disabled={true}/>
      </Col>
      <Col xs={24} md={12} xl={8}>
      <InputSelect label={"Branch"} name={"BranchId"} options={transformOptions(dataSet?.Table2)} />
      </Col>
      <Col xs={24} md={12} xl={8}>
          <InputSelect label={"Department Name"} name={"DepartmentId"} options={transformOptions(dataSet?.Table3)} />
        </Col>
        <Col xs={24} md={12} xl={8}>
          <InputDate label={"Opening Date"} name={"TransactionDate"} />
        </Col>
    </Row>
  );

  const handleDemandEdit = (DemandNumber) => {
    const selectedDemand = dummyQuotationData.find(
      (demand) => demand.DemandNumber === DemandNumber
    );

    if (selectedDemand) {
      setDrawerTableData(selectedDemand.items);
      setTimeout(() => {
        if (itemCodeRefs.current[0]) {
          itemCodeRefs.current[0].focus();
        }
      }, 100);
    }

    handleDrawer("Update");
  };

  const handleQuantityChange = (quantity, index) => {
    setDrawerTableData((prevData) => {
      const updatedData = [...prevData];
      updatedData[index] = {
        ...updatedData[index],
        Quantity: quantity,
      };
      return updatedData;
    });
  };

  const handleQuantityKeyPress = (e, itemCode, index) => {
    if (e.key === "Enter") {
      e.preventDefault();
      // Move focus to the next row's item code
      const nextIndex = index + 1;
      if (quantityRefs.current[nextIndex]) {
        quantityRefs.current[nextIndex].focus();
      }
    }
  };
  const getTransactionDetail = (data) => {
    return data.map((item) => ({
      ItemId: item.ItemId,
      UnitId: item.IssuanceUnitId, // Assuming this is the intended field
      Quantity: Number(item.Quantity),
      Rate: 0,
    }));
  };
  return (
    // <Card>
    <>
      <FormComponent
        title={"Search Demand"}
        children={searchFields}
        handleSubmit={handleSearch}
        form={search}
        submit={"Search"}
        isLoading={isLoading}
        initialValues={initialValues}
        extra={
          <ButtonComponent
            icon={<EditOutlined />}
            text={"Add"}
            size={"medium"}
            onClick={() => {
              handleDrawer();
              setDrawerTableData([]);
            }}
          />
        }
      />

      <br />
      <TableComponent
        title={"Demand List"}
        columns={mainPageTableColumns || []}
        rows={dataSet?.Table1 || []}
        loading={isTableLoading}
      />
      <DrawerComponent
        onClose={() => {
          handleDrawer(Operations.Select);
          setDrawerTableData([]);
          setFormValues({});
          setIsEdit(false);
        }}
        open={open}
        width={1000}
        extra={
          <Space>
            <ButtonComponent
              icon={<EditOutlined />}
              text={"Save"}
              size={"medium"}
              onClick={() => {
                const TransactionDetail = getTransactionDetail(drawerTableData);
                const Id = formValues?.Id || null;
                handleOpeningInventorySubmit({
                  DepartmentId: formValues.DepartmentName,
                  BranchId: null,
                  TransactionDate: formValues.TransactionDate,
                  Id: Id,
                  TransactionDetail,
                  OperationId: isEdit ? 3 : 2,
                  IsSubmit: false,
                });

                setDrawerTableData([]);
                setFormValues({});
                setIsEdit(false);
              }}
            />
            <ButtonComponent
              icon={<SaveOutlined />}
              text={"Submit"}
              size={"medium"}
              onClick={() => {
                const TransactionDetail = getTransactionDetail(drawerTableData);
                const Id = formValues?.Id || null;
                handleOpeningInventorySubmit({
                  DepartmentId: formValues.DepartmentName,
                  BranchId: null,
                  TransactionDate: formValues.TransactionDate,
                  Id: Id,
                  TransactionDetail,
                  OperationId: isEdit ? 3 : 2,
                  IsSubmit: true,
                });

                setDrawerTableData([]);
                setFormValues({});
                setIsEdit(false);
              }}
            />
          </Space>
        }
      >
        <NewFormComponent
          children={formFields}
          form={add}
          isLoading={isLoading}
          initialValues={initialValues}
          setFormValues={setFormValues}
        />
        <DemandForm
          dataSet={dataSet}
          setDrawerTableData={setDrawerTableData}
          drawerTableData={drawerTableData}
        />
        <TableComponent
          columns={drawerTableColumns || []}
          rows={drawerTableData}
          title={"Demand Items List"}
          header={true}
        />
      </DrawerComponent>
    </>
    // </Card>
  );
}
